import {Injectable} from '@angular/core';
// tslint:disable-next-line:nx-enforce-module-boundaries
import {CmsConfig} from '../config/cms.config';
import {ProductsFacade} from '@kion/data-access/data-access-products';
import {LinkRef, ResolverUrl} from '@kion/data-models';
import {ProductUrlService} from "./product-url.service";

const COOKIE_LINK = 'KionCookieConsentLinkComponent';
const FALLBACK_ROUTE = '404';

@Injectable({
  providedIn: 'root'
})
export class LinkResolverService {

  constructor(
    private cmsConfig: CmsConfig,
    private productsFacade: ProductsFacade,
    private productUrlService: ProductUrlService,
  ) {}

  private url: string;

  private static isValidExternalUrl(url: string): boolean {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return false;
    }
    try {
      const tryUrl = new URL(url);
      return true;
    } catch {
      return false;
    }
  }

  private static asBool(boolValue: string): boolean {
    return boolValue === 'true';
  }

  private static checkForLeadingSlash(url: string): boolean {
    return url.split('/')[0] === '/';
  }

  public navigate(linkRef: LinkRef): ResolverUrl {
    const ref: LinkRef = {
      ...linkRef
    };

    const isLinkRefInvalid = !this.tryNavigateByContentPage(ref)
      && !this.tryNavigateByTargetLabelOrName(ref)
      && !this.tryNavigateByProductCode(ref)
      && !this.tryNavigateByCategory(ref)
      && !this.tryNavigateByUrl(ref);

    if (isLinkRefInvalid) {
      this.executeRouting(FALLBACK_ROUTE);
    }

    const url: string = this.url.indexOf('http') !== -1 ?
      this.url :
      (LinkResolverService.checkForLeadingSlash(this.url) ? this.url : '/' + this.url);
    return {
      url: url,
      newWindow: LinkResolverService.asBool(linkRef.target as string),
      external: LinkResolverService.asBool(linkRef.external as string)
    }
  }

  private tryNavigateByContentPage(linkRef: LinkRef): boolean {
    let hasContentPage = false;

    let contentPage = linkRef?.contentPageLabelOrId;
    if (contentPage === 'home') {
      contentPage = '/'
    }

    if (contentPage) {
      this.executeRouting(contentPage);
      hasContentPage = true;
    }

    return hasContentPage;
  }

  private tryNavigateByTargetLabelOrName(linkRef: LinkRef): boolean {
    let hasContentPage = false;

    const contentPage = linkRef?.targetLabelOrName;

    if (contentPage) {
      this.executeRouting(contentPage);
      hasContentPage = true;
    }

    return hasContentPage;
  }

  private tryNavigateByProductCode(linkRef: LinkRef): boolean {
    let hasProductCode = false;

    const productCode = linkRef?.productCode;
    if (productCode) {

      const productUrl = this.productUrlService.getProductUrl(productCode);
      this.url = productUrl;

      if (productUrl) {
        hasProductCode = true;
      }
    }
    return hasProductCode;
  }


  private tryNavigateByCategory(linkRef: LinkRef): boolean {
    let hasCategory = false;

    const category = linkRef?.categoryCode;
    if (category) {
      this.executeRouting('c/' + category);
      hasCategory = true;
    }

    return hasCategory;
  }

  private tryNavigateByUrl(linkRef: LinkRef): boolean {
    let hasUrl = false;

    const url = linkRef?.url;
    if (url) {
      this.executeRouting(url, (linkRef.target as boolean) && (linkRef.external as boolean), linkRef.external as boolean);
      hasUrl = true;
    }

    return hasUrl;
  }

  private executeRouting(url: string, newTab?: boolean, external?: boolean): string {
    if (external) {
      this.url = url;
      return;
    }
    let completedUrl = url;

    this.url = completedUrl;
    return completedUrl
  }


}
